import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { AncillariesManagerFiltersData } from "../../state/AncillariesManager/FiltersData";

const updateAncillariesManagerFiltersData: Reducer<
  AncillariesManagerFiltersData
> = (
  state: AncillariesManagerFiltersData = new AncillariesManagerFiltersData(),
  action: Action<ActionType, AncillariesManagerFiltersData>
) => {
  switch (action.type) {
    case ActionType.ANCILLARIES_MANAGER_FILTERS_DATA_UPDATED:
      return { ...state, ...action.data };
    case ActionType.ANCILLARIES_MANAGER_FILTERS_DATA_RESET:
      return new AncillariesManagerFiltersData();
    default:
      return state;
  }
};

export default updateAncillariesManagerFiltersData;
